const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://ff6emzwzld.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://7cp1izsyl1.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.valeglobal.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.valeglobal.forwoodsafety.com'
  }
};

export default config;